import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import { fr } from "yup-locales";
import { setLocale } from "yup";
import { cleanerError } from "@/lib/utils";
import {
  RestaurantTable,
  RestaurantTableFormData,
} from "@/redux/services/table/table.type";
import { useCreateOrUpdateTableMutation } from "@/redux/services/table/table.api";
import { toastApiError } from "@/lib/apiErrors";

setLocale(fr);

const schema = yup.object().shape({
  code: yup.string().required().label("Code"),
  allowOrderPlacement: yup.boolean().label("Autoriser la prise de commande"),
});

const useCrudTable = (
  closeModal: () => void,
  item?: RestaurantTable,
  restaurantId?: string
) => {
  const [allowOrderPlacement, setAllowOrderPlacement] = useState(
    item?.allowOrderPlacement ?? true
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
    control,
    setValue,
  } = useForm<RestaurantTableFormData>({
    // @ts-ignore
    resolver: yupResolver(schema),
    defaultValues: {
      code: item?.code,
    },
  });

  const [createOrUpdate, { isLoading }] = useCreateOrUpdateTableMutation();

  useEffect(() => {
    if (errors) {
      cleanerError(errors, clearErrors);
    }
  }, [errors, clearErrors]);

  useEffect(() => {
    if (item?.code) {
      setValue("code", item?.code);
    } else {
      setValue("code", "");
    }
    setAllowOrderPlacement(item?.allowOrderPlacement ?? true);
  }, [item]);


  const handleAllowOrderPlacement = (checked: boolean) => {
    setAllowOrderPlacement(checked);
    setValue("allowOrderPlacement", checked);
  };

  const onSubmit = async (data: RestaurantTableFormData) => {
    const res = await createOrUpdate({
      id: item?.id,
      data: { ...data, restaurant: `api/restaurants/${restaurantId}` },
    });

    if ("data" in res) {
      closeModal();
      toast.success(`Table ${item?.id ? "modifiée" : "ajoutée"}  avec succès`);
      reset();
    } else if ("error" in res) {
      toastApiError(res.error, "Une erreur inconnue est survenue");
    }
  };

  return {
    register,
    errors,
    onSubmit: handleSubmit(onSubmit),
    isLoading,
    Controller,
    control,
    handleAllowOrderPlacement,
    allowOrderPlacement,
  };
};

export default useCrudTable;
